var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessIconGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "199px",
    height: "199px",
    viewBox: "0 0 199 199",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M138.417538,63.3684783 L84.6448604,117.602434 L60.5864481,93.3256438 C57.4861372,90.1971915 52.425544,90.1971915 49.3252332,93.3256438 C46.2249223,96.4540961 46.2249223,101.560624 49.3252332,104.689076 L79.0133672,134.646689 C80.5756138,136.223116 82.610215,137 84.6430888,137 C86.67769,137 88.7105195,136.224859 90.2728105,134.646689 L149.674767,74.7278887 C152.775078,71.5994363 152.775078,66.4929083 149.674767,63.364456 C146.548502,60.2115571 141.513863,60.2115571 138.413552,63.3662017 L138.417538,63.3684783 Z",
    id: "Path",
    fill: "#613F75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.5,0 C44.6239732,0 0,44.6239732 0,99.5 C0,154.376027 44.6239732,199 99.5,199 C154.376027,199 199,154.376027 199,99.5 C199,44.6239732 154.376027,0 99.5,0 Z M99.5,183.031138 C53.4545982,183.031138 15.9688616,145.569388 15.9688616,99.5 C15.9688616,53.4306116 53.4550424,15.9688616 99.5,15.9688616 C145.544958,15.9688616 183.031138,53.4306116 183.031138,99.5 C183.031138,145.569388 145.544958,183.031138 99.5,183.031138 Z",
    id: "Shape",
    fill: "#56E39F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessIconGreen);
export default __webpack_public_path__ + "static/media/success-icon--green.3692920043e178066216b3fccb0b0b56.svg";
export { ForwardRef as ReactComponent };